import React, { useState } from "react";
import UpdateSettings from "./UpdateSettings";
import DeleteAccount from "./DeleteAccount";
import { BuildingOfficeIcon, UserIcon } from "@heroicons/react/20/solid";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const tabs = [
  { id: "settings", name: "Paramètres", icon: UserIcon },
  { id: "deleteAccount", name: "Supprimer son compte", icon: BuildingOfficeIcon },
];

const SettingsPage = () => {
  const [currentTabId, setCurrentTabId] = useState(tabs[0].id);

  const renderTabContent = () => {
    if (currentTabId === "deleteAccount") return <DeleteAccount />;
    return <UpdateSettings />;
  };

  return (
    <div className="mx-auto max-w-5xl px-4 py-10 sm:px-6 lg:px-8">
      <header className="mb-8">
        <p className="text-sm font-bold uppercase text-sky-500 dark:text-sky-400">Compte</p>
        <h1 className="mt-2 text-3xl font-black text-slate-950 dark:text-white">Paramètres</h1>
      </header>

      <div className="mb-6 rounded-xl border border-sky-500/10 bg-white/80 p-1 shadow-sm dark:bg-slate-950/70">
        <nav aria-label="Tabs" className="grid gap-2 sm:grid-cols-2">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              type="button"
              onClick={() => setCurrentTabId(tab.id)}
              className={classNames(
                currentTabId === tab.id
                  ? "bg-sky-500/15 text-sky-700 ring-1 ring-sky-300/40 dark:text-sky-200"
                  : "text-slate-600 hover:bg-sky-500/10 hover:text-slate-950 dark:text-slate-300 dark:hover:text-white",
                "inline-flex items-center justify-center gap-2 rounded-lg px-4 py-3 text-sm font-bold transition"
              )}
            >
              <tab.icon className="size-5" />
              {tab.name}
            </button>
          ))}
        </nav>
      </div>

      <div>{renderTabContent()}</div>
    </div>
  );
};

export default SettingsPage;
